module.exports = __webpack_public_path__ + "media/images/puzzle/puzzle_99-aa0b832c9f5325e6025a37cc603aec37.png";